module.exports = __webpack_public_path__ + "media/images/nl/ICON-HERHAAL-2-aff238dc9673527f6ade6626a3ea176f.png";